module.exports = __webpack_public_path__ + "img/12.56888312.jpg";